import React from 'react'
import Manager from '../../public/components/Manager'
import HolidayManagementDetail from './HolidayManagementDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '假期名称', minWidth: 150, locked: false, flex: 2, search: true },
        { _text: '假期单位时长', minWidth: 150, flex: 2, filter: true },
        { _text: '时长单位', minWidth: 150, flex: 2, filter: true },
        { _int: '最小假期数量', minWidth: 150, flex: 2, filter: true },
        { _text: '假期类型', minWidth: 150, flex: 2, filter: true },
        { _text: '假期时段', minWidth: 150, flex: 2, filter: true },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <HolidayManagementDetail {...props} id={data.id} />)
    }
}

export default props => <Manager {...props} config={config} />